import { InvoicePaymentSearchRequest } from '@trukt/tms-api/InvoicePaymentService';

import { createKey } from './createKey';

const keyHandler = createKey('invoice-payment');

export const InvoicePaymentServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<InvoicePaymentSearchRequest>(),
};
